// 用于归因
import { request } from "@/axios";
import { ANONYMOUS_ID,getSafePlatformCode } from "@/assets/sensors";

// 搜索引擎点击进入是上报
async function ascribeClick(data: Record<string, any>) {
  return request({
    api: "/click",
    method: "post",
    data,
    notToast: false
  });
}

const ascribeFieds = ["channel", "platformCode"];

function checkAscribe() {
  const params = new URLSearchParams(window.location.search);
  return ascribeFieds.every((field) => params.has(field));
}

export function getAscribeParams() {
  const params = new URLSearchParams(window.location.search);

  return {
    accountId: params.get("accountId") || params.get("account_id"),
    anonymousId: ANONYMOUS_ID,
    channel: parseInt(params.get("channel") || ""),
    platformCode: getSafePlatformCode(),
    url: window.location.href
  };
}

const localStorageKey = "pinoReferrer";

/**
 * 检测是否为投放链接
 * 判断标准：URL 同时包含 channel 和 platformCode 参数
 * @returns {boolean} 是否为投放链接
 */
export function isPromotionLink(): boolean {
  const params = new URLSearchParams(window.location.search);
  const channel = params.get("channel");
  const platformCode = getSafePlatformCode();
  return !!channel && platformCode !== undefined;
}

/**
 * 用于上报买量归因的吧,必须有channel和platformCode才会上报
 */
export function useAscribe() {
  const localStorageReferrer = localStorage.getItem(localStorageKey);
  const shouldAscribe = checkAscribe();
  if (shouldAscribe) {
    sessionStorage.setItem("shouldAscribe", "true");
  } else {
    sessionStorage.removeItem("shouldAscribe");
  }

  if (!localStorageReferrer && shouldAscribe) {
    localStorage.setItem(localStorageKey, window.location.href);

    const params = getAscribeParams();
    ascribeClick(params);
  }
}
